// LocaleLayout — T-055. Renders locale-prefixed routes (/de, /hu, /en) in the
// requested locale without persisting it. Unknown prefixes fall through to 404.

import { useEffect } from "react";
import type { ReactElement } from "react";
import { Outlet, useParams } from "react-router-dom";
import { setLocale } from "../../i18n";
import type { Locale } from "../../types/i18n";
import { NotFoundPage } from "./NotFoundPage";

const SUPPORTED: Locale[] = ["de", "hu", "en"];

export function LocaleLayout(): ReactElement {
  const { locale: raw } = useParams<{ locale: string }>();
  const locale = (raw ?? "") as Locale;

  useEffect(() => {
    if (SUPPORTED.includes(locale)) {
      setLocale(locale);
      if (typeof document !== "undefined") {
        document.documentElement.lang = locale;
      }
    }
  }, [locale]);

  if (!SUPPORTED.includes(locale)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
